import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() => ({
  primaryColor: {
    color: '#4b2367',
    textTransform: 'capitalize',
  },
}))
